var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasActiveFilters
    ? _c(
        "CompassEmptyState",
        {
          attrs: {
            illustrationPath:
              "/ressources/logged/img/illustrations/no-results.svg",
            title: _vm.$t.__("objectives.listing.ObjectivesListing.no_result"),
            caption: _vm.$t.__(
              "objectives.listing.ObjectivesListing.try_reset_filters"
            )
          }
        },
        [
          _c("CompassButton", {
            attrs: { label: _vm.$t.__("common.actions.reset") },
            on: { click: _vm.handleResetFilters }
          })
        ],
        1
      )
    : _c(
        "CompassEmptyState",
        {
          attrs: {
            illustrationPath:
              "/ressources/logged/img/illustrations/empty-objectives.svg",
            title: _vm.$t.__(
              "objectives.listing.ObjectivesListing.maximise_objectives"
            ),
            caption: _vm.$t.__(
              "objectives.listing.ObjectivesListing.add_first_objective"
            )
          }
        },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                disabled: !_vm.buttonConfig.disabled,
                content: _vm.buttonConfig.tooltip
              }
            },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.buttonConfig.label,
                  disabled: _vm.buttonConfig.disabled,
                  "data-bot": _vm.buttonConfig.dataBot
                },
                on: {
                  click: function($event) {
                    return _vm.$router.push({
                      path: _vm.buttonConfig.callback,
                      params: {}
                    })
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }